import Vuex from 'vuex';
import { Vue } from 'vue-property-decorator';
import { config } from 'vuex-module-decorators';

config.rawError = true;

import AccountStore from './modules/account';
import OrganisationStore from './modules/organisation';
import UserStore from './modules/users';
import FormStore from './modules/forms';
import FormLabelStore from './modules/formLabels';
import FormElementStore from './modules/formElements';
import FormElementTagStore from './modules/formElementTags';
import FormElementTypeStore from './modules/formElementTypes';
import VisibilityRuleSetStore from './modules/visibilityRules';
import ReportStore from './modules/report';
import ReportElementStore from './modules/reportElement';
import ReportElementTypeStore from './modules/reportElementTypes';
import EntryStore from './modules/entry';

Vue.use(Vuex);

const vuexStore = new Vuex.Store({
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        account: AccountStore,
        organisation: OrganisationStore,
        users: UserStore,
        forms: FormStore,
        formLabels: FormLabelStore,
        formElements: FormElementStore,
        formElementTags: FormElementTagStore,
        formElementTypes: FormElementTypeStore,
        visibilityRuleSets: VisibilityRuleSetStore,
        reports: ReportStore,
        reportElements: ReportElementStore,
        reportElementTypes: ReportElementTypeStore,
        entries: EntryStore,
    },
});

export default vuexStore;
